import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgDonorsRound = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 25 25"
    >
        <rect fill="#F4F2FF" height="25" rx="12.5" width="25" />
        <path
            d="M6.7395 16.4707C6.7395 14.9581 7.96568 13.7319 9.47825 13.7319H12.1387C13.6513 13.7319 14.8775 14.9581 14.8775 16.4707C14.8775 16.6868 14.7023 16.8619 14.4862 16.8619H7.13075C6.91467 16.8619 6.7395 16.6868 6.7395 16.4707Z"
            fill="#715AFF"
        />
        <path
            d="M16.5215 13.7319C18.0339 13.7321 19.2598 14.9587 19.2598 16.4712C19.2596 16.687 19.0849 16.8616 18.8691 16.8618H16.1289V16.5493C16.1289 15.4553 15.6965 14.4632 14.9941 13.7319H16.5215Z"
            fill="#715AFF"
        />
        <circle cx="10.8253" cy="10.5032" fill="#715AFF" r="1.97687" />
        <circle cx="16.1299" cy="10.6021" fill="#715AFF" r="1.878" />
    </svg>
);

export const DonorsRoundIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgDonorsRound}
        fontSize={fontSize}
    />
);
